import React from 'react';
import { useTranslation } from 'react-i18next';
import { Titled } from 'react-titled';
import AppLayout from 'components/common/AppLayout';
import FirstAlertLogo from 'components/logos/firstAlert.svg?react';
import ResideoConnectLogo from 'components/logos/ResideoConnectLogo.png';
import AppStoreIcon from 'components/icons/appStore.svg?react';
import { RESIDEO_CONNECT_LOGO } from 'config/flags';
import GooglePlayIcon from 'components/icons/googlePlay.svg?react';
import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
  display: grid;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  grid-gap: 3rem;
  @media only screen and (min-width: 768px) {
    grid-gap: 5rem;
  }
`;

const FirstAlertContainer = styled.div`
  display: grid;
  grid-gap: 1rem;
  justify-content: center;
`;

const GetItContainer = styled.div`
  display: grid;
  grid-gap: 3rem;
  grid-auto-flow: row;
  justify-content: center;
  width: 500px;
  @media only screen and (min-width: 768px) {
    grid-auto-flow: column;
    width: auto;
  }
`;

const Text = styled.h3`
  font-size: 1.5rem;
  font-weight: 500;
  @media only screen and (min-width: 768px) {
    font-size: 2rem;
  }
`;

const Anchor = styled.a`
  svg {
    width: 260px;
    height: 80px;
  }
  @media only screen and (min-width: 768px) {
    svg {
      width: 356px;
      height: 110px;
    }
  }
`;

const DownloadTheApp = () => {
  const { t } = useTranslation();
  return (
    <Titled title={title => `${t('downloadTheApp.pageTitle')} - ${title}`}>
      <AppLayout
        showHeader={false}
        showLeftNav={false}
        showGreyPanel={false}
        showFooter={false}>
        <Container>
          <Content>
            <FirstAlertContainer>
              <FirstAlertContainer>
                {RESIDEO_CONNECT_LOGO ? (
                  <img
                    src={ResideoConnectLogo}
                    data-test-first-alert-logo
                    alt='Resideo Connect Logo'
                    width={180}
                    height={180}
                  />
                ) : (
                  <FirstAlertLogo data-test-first-alert-logo />
                )}
              </FirstAlertContainer>
              <Text>
                {t(
                  RESIDEO_CONNECT_LOGO
                    ? 'downloadTheApp.downloadTheRCAppText'
                    : 'downloadTheApp.downloadTheAppText'
                )}
              </Text>
            </FirstAlertContainer>
            <GetItContainer>
              <Anchor
                href='https://play.google.com/store/apps/details?id=com.resideo.firstalert'
                target='_blank'
                rel='noreferrer'>
                <GooglePlayIcon data-test-google-play-icon />
              </Anchor>
              <Anchor
                href='https://apps.apple.com/us/app/first-alert-by-resideo/id6457097692'
                target='_blank'
                rel='noreferrer'>
                <AppStoreIcon data-test-app-store-icon />
              </Anchor>
            </GetItContainer>
          </Content>
        </Container>
      </AppLayout>
    </Titled>
  );
};

export default DownloadTheApp;
